import { localizeWithPath, localize2WithPath } from 'vscode/vscode/vs/nls';
import { registerAction2, Action2, MenuId } from 'vscode/vscode/vs/platform/actions/common/actions';
import { IQuickInputService } from 'vscode/vscode/vs/platform/quickinput/common/quickInput.service';

const _moduleId = "vs/workbench/contrib/search/browser/searchActionsSymbol";
registerAction2(class ShowAllSymbolsAction extends Action2 {
    static { this.ID = 'workbench.action.showAllSymbols'; }
    static { this.LABEL = ( localizeWithPath(_moduleId, 0, "Go to Symbol in Workspace...")); }
    static { this.ALL_SYMBOLS_PREFIX = '#'; }
    constructor() {
        super({
            id: "workbench.action.showAllSymbols" ,
            title: {
                ...( localize2WithPath(_moduleId, 0, "Go to Symbol in Workspace...")),
                mnemonicTitle: ( localizeWithPath(_moduleId, 1, "Go to Symbol in &&Workspace...")),
            },
            f1: true,
            keybinding: {
                weight: 200 ,
                primary: 2048  | 50
            },
            menu: {
                id: MenuId.MenubarGoMenu,
                group: '3_global_nav',
                order: 2
            }
        });
    }
    async run(accessor) {
        accessor.get(IQuickInputService).quickAccess.show(ShowAllSymbolsAction.ALL_SYMBOLS_PREFIX);
    }
});
